export var mutations = {
    setLoading: function (state, loading) {
        state.loading = loading;
    },
    setPagination: function (state, pagination) {
        state.pagination = pagination;
    },
    setCandidates: function (state, candidates) {
        state.candidates = candidates;
    },
};
export var types = {
    SET_LOADING: 'setLoading',
    SET_PAGINATION: 'setPagination',
    SET_CANDIDATES: 'setCandidates',
};
